(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanDateFilter', leanDateFilter);
	
	leanDateFilter.$inject = [];
	function leanDateFilter() {
		var html = '<div class="date-menu" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();" >' +
						'<form name="dateForm" novalidate>' +
							'<div class="date-header">' +
								'<div class="date-title"><span translate> {{filterName}}</span></div>' +
							'</div>' +
							'<div class="date-body">' +
								'<div class="filter-dropdown form-group" ng-click="$event.stopPropagation();">' +
									'<select name="comparator" ng-required="true" class="form-control" ng-model="filterComparator" ng-options="(comp.name | translate) for comp in $parent.filterFunctions.comparators | filter:filterNotBetween()" ng-disabled="readOnly">' +
									'</select>' +
									'<div class="input-group">' +
									'<input name="valueOne" type="text" class="form-control" ' +
										'uib-datepicker-popup="mediumDate" is-open="openedOne" uib-datepicker-options="dateOptions" ' +
										'ng-required="true" show-button-bar="false" ng-model="filterValueOne" ng-disabled="readOnly">' +
									'<span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openOne()" ng-disabled="readOnly">' +
										'<i class="fa fa-calendar" style="line-height: 13px"></i></button></span>' +
									'</div>' +
									'<div class="input-group">' +
									'<input name="valueTwo" ng-show="filterComparator.name === ' + "'Between' || filterComparator.name === " + "'Not Between'" + '" type="text" ' +
										'class="form-control" uib-datepicker-popup="mediumDate" show-button-bar="false" is-open="openedTwo" ' +
										'uib-datepicker-options="dateOptions" ng-required="filterComparator.name === ' + "'Between' || filterComparator.name === " + "'Not Between'" + '" ng-model="filterValueTwo" ng-disabled="readOnly">' +
									'<span ng-show="filterComparator.name === ' + "'Between'" + '" class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openTwo()" ng-disabled="readOnly">' +
										'<i class="fa fa-calendar" style="line-height: 13px"></i></button></span>' +
									'</div>' +
								'</div>' +
							'</div>' +
							'<div class="date-footer" ng-show="!readOnly">' +
								'<button class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
								'	<span translate>Cancel</span>' +
								'</button>' +
								'<button class="button flat colored innerButton" data-testid="reportFilter-' + '{{filterId}}' + '-apply-btn" ng-disabled="$parent.filterFunctions.isReadOnly() || dateForm.comparator.$invalid || dateForm.valueOne.$invalid || (filterComparator.name === ' + "'Between'" + ' && dateForm.valueTwo.$invalid)" ng-click="$parent.filterFunctions.applySelection($event, filterId)">' +
									'<span translate>Apply</span>' +
								'</button>' +
							'</div>' +
						'</form>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {filterName: '@',
											filterValueOne: '=',
											filterValueTwo: '=',
											filterComparator: '=',
											filterShowNotBtw: '=',
											filterLabel: '@',
											filterId: '@'},
			link: function(scope, element, attrs) {
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				scope.excludeNotBetweenOption = !scope.filterShowNotBtw;
				scope.openOne = function() {
					scope.openedOne = true;
				};
				scope.openTwo = function() {
					scope.openedTwo = true;
				};
				scope.filterValueOne = new Date(scope.filterValueOne);
				scope.filterValueTwo = new Date(scope.filterValueTwo);

				scope.filterNotBetween = function() {
					if (scope.excludeNotBetweenOption) {
						return function( item ) {
							return item.name != 'Not Between';
						};
					} else {
						return function( item ) {
							return true;
						};
					}
				};
			}
		};
	}
})();
